module.exports = __webpack_public_path__ + "img/landing.81253b50.png";